import React from 'react';
import { HeaderNav, MainFooter } from '../components';

export const HomeLayout = (props) => {
  const { children } = props;

  return (
    <div className='home-layout'>
      <section className='header__box'>
        <HeaderNav></HeaderNav>
        {/* <MainHeader></MainHeader> */}
      </section>
      <section className='content__box'>{children}</section>
      <section className='footer__box'>
        <MainFooter></MainFooter>
      </section>
    </div>
  );
};
